import React, { useRef } from "react";
import Box from "@mui/material/Box";

export default function AssetLink({ value }) {
  const ref = useRef();

  const handleClick = e => {
    setTimeout(() => {
      const event = new MouseEvent("dblclick", {
        view: window,
        bubbles: true,
        cancelable: true,
      });
      ref.current.parentElement.dispatchEvent(event);
    }, 0);
  };

  return (
    <Box
      ref={ref}
      sx={{ cursor: "pointer" }}
      color="primary.main"
      className="unfocus"
      onMouseDown={handleClick}
      width="100%"
      height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Box>{value || ""}</Box>
    </Box>
  );
}
